<template>
  <div>
    <slot v-if="searchApi.loading" name="loading" :loading="searchApi.loading">
      Loading...
    </slot>

    <slot v-else :listings="compResults" />
  </div>
</template>

<script>
import LegacyApi from '@/lib/api/legacy'
import { shuffle } from 'lodash'

export default {
  name: 'UtilSearch',
  props: {
    searchQuery: Object,
    randomiseResults: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchApi: new LegacyApi()
    }
  },
  watch: {
    searchQuery() {
      this.search()
    }
  },
  created() {
    this.search()
  },
  computed: {
    compResults() {
      if (this.searchApi.data.length) {
        return this.randomiseResults ? shuffle(this.searchApi.data) : this.searchApi.data
      } else {
        return []
      }
    }
  },
  methods: {
    async search() {
      if (!this.searchQuery || !this.searchQuery.commodity) {
        return false
      }

      await this.searchApi.post('listings.search', this.searchQuery)

      if (this.searchApi.data.length) {
        this.$emit('foundResults')
      } else {
        this.$emit('noResults')
      }
    }
  }
}
</script>
